import styled from "styled-components";

export default styled.nav`
  background: #090426;
  width: 100vw;
`;
